(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-archive-masonry"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-blog-archive]');
  if (!root) return;

  const grid = root.querySelector('[data-masonry]');
  const ui = root.querySelector('[data-infscroll]');
  if (!grid) return;

  const btn = ui ? ui.querySelector('[data-load-more]') : null;
  const statusEl = ui ? ui.querySelector('.infscroll__status') : null;
  const sentinel = ui ? ui.querySelector('[data-sentinel]') : null;

  let loading = false;
  let msnry = null;
  let observer = null;

  const setStatus = (msg) => { if (statusEl) statusEl.textContent = msg || ''; };

  const getNextUrl = () => ui ? ui.getAttribute('data-next-url') : null;
  const setNextUrl = (url) => {
    if (!ui) return;
    if (url) ui.setAttribute('data-next-url', url);
    else ui.removeAttribute('data-next-url');
  };

  const stop = () => {
    setNextUrl(null);
    if (btn) btn.style.display = 'none';
    setStatus('No more posts.');
    if (observer) observer.disconnect();
  };

  const loadScriptOnce = (src, id) => {
    return new Promise((resolve, reject) => {
      if (id && document.getElementById(id)) return resolve();
      const s = document.createElement('script');
      if (id) s.id = id;
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  };

  const initMasonry = async () => {
    // Masonry + imagesLoaded from CDN
    await loadScriptOnce('https://unpkg.com/imagesloaded@5/imagesloaded.pkgd.min.js', 'imagesloaded-lib');
    await loadScriptOnce('https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.min.js', 'masonry-lib');

    msnry = new Masonry(grid, {
      itemSelector: '[data-tile]',
      columnWidth: '.masonry-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true,
      transitionDuration: 0
    });

    // Wait for images, then layout
    imagesLoaded(grid, () => msnry.layout());
  };

  const appendNextPage = async () => {
    const nextUrl = getNextUrl();
    if (!nextUrl || loading) return;

    loading = true;
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    setStatus('Loading…');

    try {
      const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextGrid = doc.querySelector('[data-masonry]');
      const newTiles = nextGrid ? Array.from(nextGrid.querySelectorAll('[data-tile]')) : [];

      if (newTiles.length) {
        // Append to DOM first
        newTiles.forEach((el) => grid.appendChild(el));

        // Tell Masonry about them after images load
        imagesLoaded(newTiles, () => {
          if (msnry) {
            msnry.appended(newTiles);
            msnry.layout();
          }
        });
      }

      const nextUI = doc.querySelector('[data-infscroll]');
      const newNextUrl = nextUI ? nextUI.getAttribute('data-next-url') : null;

      if (newNextUrl) {
        setNextUrl(newNextUrl);
        setStatus('');
      } else {
        stop();
      }
    } catch (e) {
      console.error(e);
      setStatus('Could not load more posts. Try again.');
    } finally {
      loading = false;
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  };

  // Boot
  initMasonry().catch((e) => {
    console.error(e);
    setStatus('Masonry failed to load.');
  });

  if (btn) btn.addEventListener('click', appendNextPage);

  // Auto infinite scroll
  if ('IntersectionObserver' in window && sentinel && ui) {
    observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry && entry.isIntersecting) appendNextPage();
    }, { rootMargin: '600px 0px' });

    observer.observe(sentinel);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.getElementById("SearchDrawer");
  if (!drawer) return;

  const input = drawer.querySelector("input[type='search']");
  const results = document.getElementById("PredictiveResults");
  const closeBtn = document.getElementById("SearchDrawerClose");

  const root = (
    window.Shopify?.routes?.root || drawer.dataset.routesRoot || "/"
  ).replace(/\/$/, "");

  const isVIP = drawer.dataset.vip === "true";
  const discountPct = Number(drawer.dataset.discountPct);

  const money = new Intl.NumberFormat(drawer.dataset.locale || "en-GB", {
    style: "currency",
    currency: drawer.dataset.currency || "GBP",
  });

  const formatMoney = (cents) => money.format(cents / 100);
  const productCache = new Map();

  let searchVersion = 0;
  let opener;

  function openDrawer(button) {
    opener = button;
    drawer.classList.add("is-open");
    document.documentElement.classList.add("overflow-hidden");
    input.focus();
  }

  function closeDrawer() {
    searchVersion += 1;
    productCache.clear();
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("overflow-hidden");
    results.replaceChildren();
    input.value = "";
    opener?.focus();
  }

  document.querySelectorAll("[data-open-search]").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      openDrawer(button);
    });
  });

  closeBtn.addEventListener("click", closeDrawer);

  drawer.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      closeDrawer();
    }
  });

  function localizeUrl(url) {
    const target = new URL(url, window.location.origin);
    const path = target.pathname;

    if (root && path !== root && !path.startsWith(`${root}/`)) {
      return `${root}${path}${target.search}${target.hash}`;
    }

    return `${path}${target.search}${target.hash}`;
  }

  async function fetchJSON(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Request failed (${response.status})`);
    return response.json();
  }

  function getProduct(handle) {
    const url = `${root}/products/${encodeURIComponent(handle)}.js`;

    if (!productCache.has(url)) {
      const request = fetchJSON(url).catch((error) => {
        if (productCache.get(url) === request) productCache.delete(url);
        throw error;
      });

      productCache.set(url, request);
    }

    return productCache.get(url);
  }

  function appendText(parent, text, className) {
    const span = document.createElement("span");
    span.className = className;
    span.textContent = text;
    parent.append(span);
  }

  async function renderProduct(result) {
    const link = document.createElement("a");
    link.href = localizeUrl(result.url);
    link.className = "flex items-center gap-4 p-3 rounded hover:bg-gray-100 transition";

    const imageBox = document.createElement("div");
    imageBox.className = "w-16 h-16 flex-shrink-0 overflow-hidden rounded border border-gray-200 bg-gray-100";

    const image = document.createElement("img");
    image.src = result.image || drawer.dataset.placeholderImage;
    image.alt = "";
    image.className = "w-full h-full object-cover";
    imageBox.append(image);

    const details = document.createElement("div");
    details.className = "flex flex-col";
    appendText(details, result.title, "font-medium text-black");
    link.append(imageBox, details);

    try {
      const product = await getProduct(result.handle);
      const tags = product.tags.map((tag) => tag.trim().toLowerCase());
      const price = product.price_min;

      if (tags.includes("enquire")) {
        appendText(details, "Price on request", "text-sm text-gray-600");
      } else if (Number.isFinite(price)) {
        if (isVIP && tags.includes("sale")) {
          const salePrice = Math.round(price * (100 - discountPct) / 100);

          appendText(details, formatMoney(price), "text-sm text-gray-500 line-through mr-1");
          appendText(details, `Now ${formatMoney(salePrice)}`, "text-sm font-semibold text-black");
        } else {
          appendText(details, formatMoney(price), "text-sm text-gray-600");
        }
      }
    } catch (error) {
      console.warn("Search price unavailable for", result.handle, error);
    }

    return link;
  }

  function showMessage(message) {
    const paragraph = document.createElement("p");
    paragraph.className = "p-4 text-center text-gray-500";
    paragraph.textContent = message;
    results.replaceChildren(paragraph);
  }

  input.addEventListener("input", async () => {
    const version = ++searchVersion;
    const query = input.value.trim();

    if (!query) {
      results.replaceChildren();
      return;
    }

    const params = new URLSearchParams({
      q: query,
      "resources[type]": "product",
      "resources[limit]": "6",
      "resources[options][fields]": "title,product_type,variants.title",
    });

    try {
      const data = await fetchJSON(`${root}/search/suggest.json?${params}`);
      if (version !== searchVersion) return;

      const products = data.resources.results.products;

      if (!products.length) {
        showMessage("No results found.");
        return;
      }

      const links = await Promise.all(products.map(renderProduct));
      if (version === searchVersion) results.replaceChildren(...links);
    } catch (error) {
      if (version !== searchVersion) return;

      console.error("Predictive search error", error);
      showMessage("Something went wrong.");
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
